import { Dossier, DossierOpenSearch, useFormaliteService } from '@europrocurement/l2d-domain';
import {
    ApiDossiersIdActionPutActionEnum,
    ApiDossiersIdTransitionsGetCollection200Response,
} from '@europrocurement/l2d-domain/openApi/ApiFormalite';
import { STEP_DRAFT, STEP_TRANSMITTED } from '../constants';

type Transition = ApiDossiersIdActionPutActionEnum;

const useTransition = () => {
    const { dossierApi } = useFormaliteService();

    const softActionSteps = [STEP_DRAFT, STEP_TRANSMITTED];

    const canApplyTransition = (dossier: DossierOpenSearch, transition: Transition): boolean =>
        (dossier?.transitions || []).includes(transition);

    const applyTransition = (
        dossier: DossierOpenSearch,
        transition: Transition,
    ): Promise<Dossier> =>
        new Promise((resolve, reject) => {
            dossierApi
                .apiDossiersIdActionPut({ id: dossier?.id as number, action: transition })
                .then((res) => resolve(res.data as Dossier))
                .catch((err) => reject(err));
        });

    const getTransitionStatusAvailable = (
        dossier: DossierOpenSearch,
    ): Promise<ApiDossiersIdTransitionsGetCollection200Response> => {
        let getTransitionsTimeout: number | undefined;
        return new Promise((resolve, reject) => {
            clearTimeout(getTransitionsTimeout);
            getTransitionsTimeout = setTimeout(() => {
                dossierApi
                    .apiDossiersIdTransitionsGetCollection({
                        id: dossier?.id as number,
                    })
                    .then((res) => resolve(res.data))
                    .catch((err) => reject(err));
            }, 300);
        });
    };

    return { canApplyTransition, applyTransition, softActionSteps, getTransitionStatusAvailable };
};

export default useTransition;
